export default __webpack_public_path__ + "3715cbb.png";